module.exports = __webpack_public_path__ + "img/error-404-graphic.40d51a1b.svg";